import { RSAA } from "redux-api-middleware";
import * as types from "../types/index";
import { API_ENDPOINT, AUTH_HEADERS } from "../../config/ApiConstants";

export function markPathwayComplete_API_Action(token, data, groupId) {
  return {
    [RSAA]: {
      endpoint: `${API_ENDPOINT}/me/pathway/mark-complete`,
      method: "POST",
      headers: {
        ...AUTH_HEADERS,
        Authorization: "Bearer " + token,
        groupId: groupId
      },
      body: JSON.stringify(data),
      types: [
        types.MARK_PATHWAY_COMPLETE_REQUEST,
        types.MARK_PATHWAY_COMPLETE_RECEIVE,
        {
          type: types.MARK_PATHWAY_COMPLETE_FAILURE,
          meta: (action, state, res) => {
            return action, state, res;
          },
        },
      ],
    },
  };
}

export const reset_markPathwayComplete_API_Action = () => {
  return {
    type: types.RESET_MARK_PATHWAY_COMPLETE,
    payload: null,
  };
};
